import React from 'react';

const Privacy = () => {
  return (
    <div className="bg-[#121212] text-white min-h-screen py-20 px-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-[#FFC107] mb-8">Política de Privacidade</h1>
        
        <div className="prose prose-invert max-w-none text-gray-300 leading-relaxed space-y-6">
          <p>Última atualização: Janeiro de 2026</p>
          
          <section>
            <h2 className="text-2xl font-semibold text-[#007BFF] mb-4">1. Introdução</h2>
            <p>
              Esta Política de Privacidade descreve como coletamos, usamos e protegemos suas informações 
              ao utilizar meus serviços de análise de dados e ao navegar neste site. Como analista de dados, 
              prezo pela transparência e segurança total dos seus ativos de informação.
            </p>
          </section>

          {/* COLE O SEU TEXTO GERADO AQUI ABAIXO */}
          <section>
            <h2 className="text-2xl font-semibold text-[#007BFF] mb-4">2. Coleta de Dados</h2>
            <p>
              Coletamos informações fornecidas voluntariamente por você através de formulários de contato 
              e WhatsApp. Além disso, utilizamos o Google Analytics 4 (GA4) para entender o comportamento 
              de navegação e melhorar sua experiência no site.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#007BFF] mb-4">3. Uso de Cookies</h2>
            <p>
              Utilizamos cookies para analisar o tráfego do site. Você pode optar por desativar os cookies 
              nas configurações do seu navegador, embora isso possa afetar algumas funcionalidades do site.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#007BFF] mb-4">4. Contato</h2>
            <p>
              Se tiver dúvidas sobre esta política, entre em contato diretamente pelo WhatsApp: 
              <span className="text-[#FFC107] ml-2">+55 88 99652-7079</span>
            </p>
          </section>
        </div>
        
        <div className="mt-12">
          <a href="/" className="text-[#FFC107] hover:underline">← Voltar para o Início</a>
        </div>
      </div>
    </div>
  );
};

export default Privacy;